var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup6Updated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95579 23L5.21479 20.5357L11.3418 17.25L11.6871 13.9643L1.89947 4.92857L2.24481 1.64286H7.2005L7.37317 0H14.8067H22.2403L22.0676 1.64286H27.0233L26.6779 4.92857L14.9909 13.9643L14.6456 17.25L20.0819 20.5357L19.8229 23H12.3893H4.95579ZM7.85378 3.28571H4.54999L4.46365 4.10714L7.50844 6.57143L7.85378 3.28571ZM21.069 3.28571H24.3728L24.2864 4.10714L20.7236 6.57143L21.069 3.28571Z",
    fill: "#56628B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6868 11.4249C11.8983 11.4249 11.2786 10.3264 11.4617 8.73505L11.9405 4.0877C12.0954 2.58084 12.8418 1.65137 14.4473 1.65137C16.1372 1.65137 16.6724 2.59492 16.5175 4.00321L16.4611 4.55244L14.9965 4.55244L15.0528 4.01729C15.1232 3.35539 14.9683 2.98924 14.3628 2.98924C13.7995 2.98924 13.6164 3.39764 13.546 3.97504L13.3347 6.03114H13.3488C13.6164 5.58049 14.067 5.25658 14.6867 5.25658C15.9119 5.25658 16.433 6.08747 16.264 7.76333L16.1231 9.15754C15.9682 10.6362 15.2218 11.4249 13.6868 11.4249ZM13.6868 10.1152C14.236 10.1152 14.4754 9.7631 14.5318 9.15754L14.7008 7.49576C14.7571 6.87611 14.5599 6.53812 14.0107 6.53812C13.5178 6.53812 13.2502 6.83386 13.1939 7.41126L13.0108 9.15754C12.9404 9.79127 13.1657 10.1152 13.6868 10.1152Z",
    fill: "#161C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup6Updated);
export default __webpack_public_path__ + "static/media/cup-6-updated.326e8cdad25f947512b5208dd6849a8b.svg";
export { ForwardRef as ReactComponent };